import { Text } from '@wix/design-system';
import React from 'react';
import { useIsStudioNewUi } from '../../../hooks';
import { useCurrentModule } from '../../ModuleProvider';
import styles from '../RevShare.scss';
export const RevShareCheckoutSubtitle = _ref => {
  let {
    formattedAmount
  } = _ref;
  const module = useCurrentModule();
  const {
    Trans,
    t
  } = module.internals.useTranslations();
  const isStudioNewUi = useIsStudioNewUi();
  if (formattedAmount) {
    return /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "studio_package_picker.header.purchase.revshare.subtitle",
      components: {
        strong: /*#__PURE__*/React.createElement(Text, {
          weight: "bold",
          className: isStudioNewUi ? styles.newUiRevShareAmount : styles.revShareAmount
        })
      },
      values: {
        amountEarned: formattedAmount
      }
    }));
  }
  return /*#__PURE__*/React.createElement(Text, null, t('studio_package_picker.header.purchase.no_revshare.subtitle'));
};
//# sourceMappingURL=RevShareCheckoutSubtitle.js.map